module.exports = __webpack_public_path__ + "ca0b191d4685003ff472fa251ce17a09.svg";